export const BurgerIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.03846 5C3.46494 5 3 5.43843 3 5.97926C3 6.52009 3.46494 6.95852 4.03846 6.95852H12H19.9615C20.5351 6.95852 21 6.52009 21 5.97926C21 5.43843 20.5351 5 19.9615 5H4.03846ZM4.03846 10.2227C3.46494 10.2227 3 10.6611 3 11.202C3 11.7428 3.46494 12.1812 4.03846 12.1812H19.9615C20.5351 12.1812 21 11.7428 21 11.202C21 10.6611 20.5351 10.2227 19.9615 10.2227H4.03846ZM3 17.0207C3 16.4799 3.46494 16.0415 4.03846 16.0415H19.9615C20.5351 16.0415 21 16.4799 21 17.0207C21 17.5616 20.5351 18 19.9615 18H4.03846C3.46494 18 3 17.5616 3 17.0207Z"
				fill="white"
			/>
		</svg>
	)
}
